import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | anon

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("vrax_token");
    if (!token) { setStatus("anon"); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setStatus("authed");
    } catch {
      localStorage.removeItem("vrax_token");
      localStorage.removeItem("vrax_user");
      setStatus("anon");
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (username, password) => {
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("vrax_token", data.token);
      localStorage.setItem("vrax_user", JSON.stringify(data.user));
      setUser(data.user);
      setStatus("authed");
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("vrax_token");
    localStorage.removeItem("vrax_user");
    setUser(null);
    setStatus("anon");
  };

  return (
    <AuthContext.Provider value={{ user, status, login, logout, refresh: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
